import React from "react";
import { Box, Button, Typography } from "@mui/material";
import CustomTextField from "./common/CustomTextField";
import { COLORS } from "../assets/theme";

interface TestingSectionProps {
  content?: string;
  setContent: (value: string) => void;
  value?: string;
  setValue: (value: string) => void;
  handleTestClick: () => void;
}

const TestingSection: React.FC<TestingSectionProps> = ({
  content = "",
  setContent,
  value = "",
  setValue,
  handleTestClick,
}) => {
  const handleContentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newContent = e.target.value;
    setContent(newContent);
    console.log("Content updated:", newContent);
  };

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const enhancedTestClick = () => {
    if (!content) {
      setValue("Error: Content is empty.");
      return;
    }

    const isNumeric = /^\d+$/.test(content);
    const result = isNumeric
      ? `Valid Numeric Content: ${content}`
      : `Processed Content: ${content.toUpperCase()}`;

    setValue(result);

    handleTestClick();
  };

  return (
    <div style={{ width: "100%" }}>
      <Box>
        <Typography>Test</Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "stretch", sm: "center" },
            gap: { xs: 2, sm: 1 },
            marginBottom: 2,
            justifyContent: { xs: "flex-start", sm: "center" },
            width: "100%",
          }}
        >
          <CustomTextField
            name="content"
            placeholder="Content"
            bgColor={COLORS.WhiteBackground}
            value={content}
            onChange={handleContentChange}
            minWidth="200px"
            fullWidth
            highlightLabelStar={false}
            sx={{
              flex: 1,
              mb: { xs: 1, sm: 0 },
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused fieldset": {
                  borderColor: "transparent",
                  boxShadow: "none",
                },
              },
            }}
          />

          <Button
            onClick={enhancedTestClick}
            aria-label="Test content"
            sx={{
              height: "35px",
              width: { xs: "100%", sm: "50px" },
              background: "#A39455",
              color: "#fff",
              // m: 1,
              fontSize: "12px",
              fontWeight: 400,
              lineHeight: "22px",
              letterSpacing: "-0.41px",
              textAlign: "center",
              textTransform: "none",
              padding: 0,
              minWidth: { xs: "100%", sm: 50 },
              border: "none",
              borderRadius: "12px",
              mb: { xs: 1, sm: 0 },
              "&:hover": {
                backgroundColor: "#A39455",
              },
            }}
          >
            Test
          </Button>

          <CustomTextField
            name="value"
            placeholder="Value"
            bgColor={COLORS.WhiteBackground}
            value={value}
            onChange={handleValueChange}
            fullWidth={true}
            minWidth="200px"
            borderRadius="12px"
            InputProps={{
              readOnly: true,
            }}
            sx={{
              flex: 1,
              mb: { xs: 1, sm: 0 },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderRadius: "12px",
                },
              },
            }}
          />
        </Box>
      </Box>
    </div>
  );
};

export default TestingSection;
